<template>
  <a class="btn btn-primary" v-if="showComponent" @click="createFutureAddress"> Toekomstig adres aanmaken</a>
</template>

<script>
import CustomerPropertyApi from "~/api/customer_property";

export default {
  name: "AXCreateFutureAddressComponent",
  props: {
    customerId: {
      type: [Number, String],
      required: true,
    },
    mortgageId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      showComponent: true,
    }
  },
  methods: {
    createFutureAddress() {
      CustomerPropertyApi.createAsFutureByMortgage(this.customerId, this.mortgageId).then(() => {
        this.$notification['success']({
          message: 'Opgeslagen',
          description: 'Het toekomstig adres is aangemaakt.',
        });
        this.$notification['warning']({
          message: 'Let op',
          description: 'Het adres wordt automatisch gewijzigd op de passeerdatum als dit in de instellingen is ingeschakelt.',
        });
        this.showComponent = false;
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om het toekomstig adres aan te maken.',
        })
      });
    },
  },
}
</script>